import { CreateAvenantPage } from "@features/rh/contrats/components/avenants/CreateAvenantPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FilePlus } from "lucide-react";
import { z } from "zod";

const searchSchema = z.object({
  type: z.string().optional(),
});

export const Route = createFileRoute("/_app/rh/contrats/$id/avenants/create")({
  validateSearch: searchSchema,
  loader: requirePermission(PERMISSIONS.RH.AVENANTS.CREATE),
  staticData: {
    title: "Créer un avenant",
    icon: FilePlus,
    permission: PERMISSIONS.RH.AVENANTS.CREATE,
    section: "App",
    showInBreadcrumb: true,
  },
  component: CreateAvenantRoute,
});

function CreateAvenantRoute() {
  const { id } = Route.useParams();
  const { type } = Route.useSearch();
  return <CreateAvenantPage contratId={Number.parseInt(id, 10)} type={type} />;
}
